export default "__VITE_ASSET__DMHkfRsR__"